import React, { useState, useEffect } from 'react';
import { Link, Route, Routes, useLocation, useParams} from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from './LanguageContext';
import i18n from './i18n'
import  '../layout/flaticon.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrows, faHeart, faL } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import { matelec,sobreMatelec } from '../matelecGallery';
function UpcomingEvent() {
  const [selectedImage, setSelectedImage] = useState(null);
  const { t, i18n } = useTranslation('');
  // Função para abrir o modal
  const openFullscreen = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  // Função para fechar o modal
  const closeFullscreen = () => {
    setSelectedImage(null);
  };

  const [expandedItems, setExpandedItems] = useState([]);
  const toggleText = (itemId) => {
    if (expandedItems.includes(itemId)) {
      setExpandedItems(expandedItems.filter(id => id !== itemId));
    } else {
      setExpandedItems([...expandedItems, itemId]);
    }
  };
    const TEXT_LIMIT = 150; 
  return (
    <>
    <section
  className="hero-wrap" style={{ backgroundImage: 'url("../images/feiras/matelec/gallery2025/Madridfeira.jpg")' }}>
  <div className="overlay" />
  <div className="container-fluid">
    <div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true" >
      <div className="col-md-12 ftco-animate text-center pt-5 fadeInUp ftco-animated main-text-block">
        <h1 className="mb-4">
        <Trans i18nKey="proxevento.bigTitle">
          <span />
          <span />
        </Trans>
        </h1>
        <p className="loc-date">
          <span>
            <i className="fa fa-map-marker" />{t('proxevento.local')}
          </span>
          <span>
            <i className="fa fa-calendar" /> {t('proxevento.data')}
          </span>
        </p>
      </div>
    </div>
  </div>
</section>

<section className="ftco-section ftco-about ftco-no-pt ftco-no-pb img">
  <div className="container">
    <div className="row d-flex">
      <div className="col-md-12 about-intro">
        <div className="row d-flex">
          <div className="col-md-6 d-flex align-items-stretch">
            <div className="img d-flex align-items-center align-self-stretch justify-content-center"
              style={{ backgroundImage: 'url("../images/feiras/matelec/gallery2025/Madridfeira.jpg")' }} ></div>
          </div>
          <div className="col-md-6 pl-md-5 py-5">
            <div className="row justify-content-start pb-3 pt-md-5">
              <div className="col-md-12 heading-section ftco-animate fadeInUp ftco-animated">
                <h2 className="mb-4">{t('proxevento.matelecoquee')}</h2>
                <p> {t('proxevento.aboutMatelec')} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="about" className="ftco-section ftco-about ftco-no-pt ftco-no-pb img">
  <div className="container">
    <div className="row d-flex">
      <div className="col-12 about-intro">
        <div className="section-title-header text-center">
          <h1 className="section-title wow fadeInUp animated"
            data-wow-delay="0.2s"
            style={{
              visibility: "visible",
              WebkitAnimationDelay: "0.2s",
              MozAnimationDelay: "0.2s",
              animationDelay: "0.2s" }} >
            {t('proxevento.sobreEven')}
          </h1>
        </div>
      </div>
    </div>

    <div className="row">
{sobreMatelec.map((item) => {
        const isExpanded = expandedItems.includes(item.id);
        const buttonText = isExpanded  ? t('proxevento.lermenos') : t('noticias.lermais');
        const fullText = item.text[i18n.language];
        const displayText = isExpanded || fullText.length <= TEXT_LIMIT ? fullText : `${fullText.substring(0, TEXT_LIMIT)}...`;
        const shouldShowButton = fullText.length > TEXT_LIMIT;
        return (
          <div className="col-xs-12 col-md-6 col-lg-6" key={item.id}>
            <div className="about-item">
              <div className='img-block'>
                <img className="img-fluid" src={item.linkImg} alt="" />
              </div>
              <div className="about-text">
                <h3> <a href="#">{item.title[i18n.language]}</a></h3>
                <p>{displayText}</p> 
                {shouldShowButton && (
                  <a  className="btn btn-common btn-rm"  href="#" 
                    onClick={(e) => {e.preventDefault(); toggleText(item.id); }} >
                    {buttonText}
                  </a>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</section>
<section className="ftco-section ftco-counter img" id="section-counter"  style={{ backgroundImage: 'url("../images/feiras/matelec/gallery2025/counterBg.png")' }} >
  <div className='title-counter'>{t('proxevento.title')}</div>
  <div className="overlay" />
  <div className="container">
    <div className="row">
      <div className="col-md-3 d-flex counter-wrap ftco-animate fadeInUp ftco-animated">
        <div className="block-18 d-flex align-items-center">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="fi fi-ts-land-location" />
          </div>
          <div className="text p-3">
            <strong className="number" data-number={301}> 17.000 </strong>
            <span>{t('proxevento.m2')}</span>
          </div>
        </div>
      </div>
      <div className="col-md-3 d-flex counter-wrap ftco-animate fadeInUp ftco-animated">
        <div className="block-18 d-flex align-items-center">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="fi fi-tr-leader-speech" />
          </div>
          <div className="text p-3">
            <strong className="number" data-number={102}>+ 24.000 </strong>
            <span>{t('proxevento.profi')}</span>
          </div>
        </div>
      </div>
      <div className="col-md-3 d-flex counter-wrap ftco-animate fadeInUp ftco-animated">
        <div className="block-18 d-flex align-items-center">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="fi fi-ts-corporate" />
          </div>
          <div className="text p-3">
            <strong className="number" data-number={1050}>+ 550</strong>
            <span>{t('proxevento.regis')}</span>
          </div>
        </div>
      </div>
      <div className="col-md-3 d-flex counter-wrap ftco-animate fadeInUp ftco-animated">
        <div className="block-18 d-flex align-items-center">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="fi fi-ts-world" />
          </div>
          <div className="text p-3">
            <strong className="number" data-number={61}> 64 </strong> <span>{t('proxevento.paises')}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="ftco-section ftco-no-pt ftco-no-pb gallery-photos">
  <div className="container">
    <div className="row pb-4 justify-content-center">
      <div className="col-md-7 heading-section text-center ftco-animate fadeInUp ftco-animated">
        <span className="subheading">Gallery</span>
        <h2 className="">{t('proxevento.fotos')}</h2>
      </div>
    </div>
  </div>
  <div className="container-fluid">

    <div className="row no-gutters">
      {matelec.map((item, index) => (
        <div className="col-md-3 ftco-animate fadeInUp ftco-animated" key={item.id} >
          <a href={item.linkImg} className="project-wrap image-popup img d-flex align-items-center justify-content-center"
            style={{ backgroundImage: `url(${item.linkImg})` }} onClick={(e) => {e.preventDefault(); openFullscreen(item.linkImg); }}>
            <div className="icon d-flex align-items-center justify-content-center">
              <span className="fa fa-search" />
            </div>
          </a>
        </div>
      ))}
    </div>

    {selectedImage && (
        <div className="fullscreen-modal" onClick={closeFullscreen}>
          {/* Botão de Fechar */}
          <button className="close-button" onClick={closeFullscreen}>
            &times;
          </button>
          
          <div className="modal-content-wrapper">
            <img  src={selectedImage} alt="Fullscreen" className="fullscreen-image" onClick={(e) => e.stopPropagation()}  />
          </div>
        </div>
      )}
  </div>
</section>

<div className='website'>
  <button className="link-site">
  <a className='' href="https://www.ifema.es/en/matelec" target='_blank'>{t('proxevento.site')}</a>
  </button>
</div>

<div className="gmap_canvas">
  <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=Ifema%20Madrid&t=m&z=10&output=embed&iwloc=near" title="Ifema Madrid"/>
</div>

    </>
  )
}

export default UpcomingEvent